import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './AnswerQuestion.css'; 
const SERVER_URL = process.env.REACT_APP_TEST_API_URL;

const AnswerQuestion = () => {
  const { id } = useParams(); // Get the question ID from URL
  const navigate = useNavigate();

  // State for the question and answer
  const [question, setQuestion] = useState(null);
  const [answerText, setAnswerText] = useState('');
  
  // Fetch question details when component mounts
  useEffect(() => {
    const fetchQuestionDetails = async () => {
      try {
        console.log("id")
        console.log(id)
        const response = await fetch(`${SERVER_URL}/api/doctor/getQuestion/${id}`);
        const result = await response.json();
        setQuestion(result);

        // Check if there's an existing answer
        if (result.answer) {
            setAnswerText(result.answer?.text);
        }

      } catch (error) {
        console.error('Error fetching question details:', error);
        alert('Failed to fetch question details');
      }
    };

    fetchQuestionDetails();
  }, [id]);

  // Handle answer submission
  const handleSubmitAnswer = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${SERVER_URL}/api/doctor/answer`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          questionId: id,
          answer: answerText,
          status: 'answered'
        }),
      });

      if (response.ok) {
        alert('Answer submitted successfully');
        navigate('/askDoctor'); // Navigate back to questions list
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to submit answer');
      }
    } catch (error) {
      console.error('Error submitting answer:', error);
      alert(error.message);
    }
  };

  // If question is not loaded yet
  if (!question) {
    return <div>Loading question details...</div>;
  }

  return (
    <div className="answer-question-container">
      <h2>Answer Question</h2>
      
      <div className="question-details">
        <h3>Original Question</h3>
        <p><strong>Concern:</strong> {question.concern}</p>
        <p><strong>Question:</strong> {question.question}</p>
        
        {question.imageUrl && (
          <div className="question-image">
            <img 
              src={SERVER_URL+'/'+question.imageUrl} 
              alt="Question Visual" 
              style={{ 
                maxWidth: '300px', 
                maxHeight: '300px' 
              }} 
            />
          </div>
        )}
      </div>

      <form onSubmit={handleSubmitAnswer} className="answer-form">
        <div className="form-group">
          <label htmlFor="answer">Your Answer</label>
          <textarea
            id="answer"
            value={answerText}
            onChange={(e) => setAnswerText(e.target.value)}
            placeholder="Type your answer here..."
            required
            rows="6"
          />
        </div>
        
        <div className="form-actions">
          <button type="submit" className="btn-submit">Submit Answer</button>
          <button 
            type="button" 
            className="btn-cancel"
            onClick={() => navigate('/askDoctor')}
          >
            Cancel
          </button>
        </div>
      </form>
    
    </div>
  );
};

export default AnswerQuestion;